"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));
var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _types = require("./worker/types");
var _utils = require("./worker/utils");
var _ramlClient = require("./worker/ramlClient");
var _excluded = ["messageId", "type"],
  _excluded2 = ["ramlResolver"];
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2.default)(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var singletonWorker;
/**
 * Map where message callbacks are
 * indexed by message ID generated in "doWorkMessageSync" fn
 */
var messageCallbacksById = {};
var defaultFn = function defaultFn() {
  return undefined;
};

/**
 * Creates a uniq worker for all Sandbox components
 *
 * @param workerPath Path used to load the workers
 *
 * @param handleAddExtraLib Fn used as callback to add new lib in
 * monaco in case a new API is created
 *
 * @param ramlResolver Fn used to return the requested raml
 */
var createWorker = function createWorker(workerPath, handleAddExtraLib, ramlResolver) {
  if (!singletonWorker) {
    singletonWorker = new Worker(workerPath);
    /**
     * Sends a message to the worker and this message is resolved
     * once the worker responds with the same messageId of this promise.
     */
    singletonWorker.doWorkerMessageSync = function (message) {
      return new Promise(function (resolve) {
        var _message$messageId;
        var messageId = (_message$messageId = message.messageId) !== null && _message$messageId !== void 0 ? _message$messageId : (0, _utils.generateId)();
        messageCallbacksById[messageId] = resolve;
        singletonWorker.postMessage(_objectSpread(_objectSpread({}, message), {}, {
          messageId: messageId
        }));
      });
    };
    singletonWorker.onmessage = /*#__PURE__*/function () {
      var _ref = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee(event) {
        var _messageCallbacksById;
        var _event$data, messageId, type, returnedMessage, resolve, oauth2Result, ramlResponse;
        return _regenerator.default.wrap(function (_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _event$data = event.data, messageId = _event$data.messageId, type = _event$data.type, returnedMessage = (0, _objectWithoutProperties2.default)(_event$data, _excluded);
              resolve = (_messageCallbacksById = messageCallbacksById[messageId]) !== null && _messageCallbacksById !== void 0 ? _messageCallbacksById : defaultFn;
              if (!(type === _types.ADD_EXTRA_LIB_TYPE)) {
                _context.next = 1;
                break;
              }
              handleAddExtraLib(returnedMessage);
              return _context.abrupt("return");
            case 1:
              if (!(type === _types.OAUTH2_RUN_TYPE)) {
                _context.next = 3;
                break;
              }
              _context.next = 2;
              return (0, _ramlClient.runOauth2Flow)(returnedMessage);
            case 2:
              oauth2Result = _context.sent;
              singletonWorker.postMessage(_objectSpread(_objectSpread({
                type: _types.OAUTH2_RESOLVE_TYPE
              }, oauth2Result), {}, {
                messageId: messageId
              }));
              return _context.abrupt("return");
            case 3:
              if (!(type === _types.RAML_RESOLVER_TYPE)) {
                _context.next = 5;
                break;
              }
              _context.next = 4;
              return (0, _ramlClient.runRAMLResolver)(ramlResolver, returnedMessage);
            case 4:
              ramlResponse = _context.sent;
              singletonWorker.postMessage(_objectSpread(_objectSpread({
                type: _types.RAML_CREATE_TYPE
              }, ramlResponse), {}, {
                messageId: messageId
              }));
              return _context.abrupt("return");
            case 5:
              /** Delete already used callback before resolving */
              delete messageCallbacksById[messageId];
              resolve(returnedMessage);
            case 6:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function (_x) {
        return _ref.apply(this, arguments);
      };
    }();
  }
  return singletonWorker;
};
var Sandbox = exports.default = /*#__PURE__*/function () {
  function Sandbox() {
    (0, _classCallCheck2.default)(this, Sandbox);
    (0, _defineProperty2.default)(this, "worker", {});
    (0, _defineProperty2.default)(this, "isRegistered", false);
  }
  return (0, _createClass2.default)(Sandbox, [{
    key: "execute",
    value: (/** Executes a notebook run */function () {
      var _execute = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee2(code, blockNumber) {
        var _this$worker;
        var _yield$this$worker$do, result, error, _t;
        return _regenerator.default.wrap(function (_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              if ((_this$worker = this.worker) !== null && _this$worker !== void 0 && _this$worker.doWorkerMessageSync) {
                _context2.next = 1;
                break;
              }
              return _context2.abrupt("return", {
                blockNumber: blockNumber,
                result: null,
                error: 'Worker could not be initialized'
              });
            case 1:
              _context2.prev = 1;
              _context2.next = 2;
              return this.worker.doWorkerMessageSync({
                type: _types.NOTEBOOK_TYPE,
                blockNumber: blockNumber,
                code: code
              });
            case 2:
              _yield$this$worker$do = _context2.sent;
              result = _yield$this$worker$do.result;
              error = _yield$this$worker$do.error;
              return _context2.abrupt("return", {
                blockNumber: blockNumber,
                result: result,
                error: error
              });
            case 3:
              _context2.prev = 3;
              _t = _context2["catch"](1);
              return _context2.abrupt("return", {
                blockNumber: blockNumber,
                result: null,
                error: _t
              });
            case 4:
            case "end":
              return _context2.stop();
          }
        }, _callee2, this, [[1, 3]]);
      }));
      function execute(_x2, _x3) {
        return _execute.apply(this, arguments);
      }
      return execute;
    }() /** Registers the notebook the first time it is created */)
  }, {
    key: "register",
    value: (function () {
      var _register = (0, _asyncToGenerator2.default)(/*#__PURE__*/_regenerator.default.mark(function _callee3(ramlClientConfig, workerPath, handleAddExtraLib) {
        var ramlResolver, clientConfig;
        return _regenerator.default.wrap(function (_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              if (!this.isRegistered) {
                _context3.next = 1;
                break;
              }
              return _context3.abrupt("return");
            case 1:
              ramlResolver = ramlClientConfig.ramlResolver, clientConfig = (0, _objectWithoutProperties2.default)(ramlClientConfig, _excluded2);
              this.worker = createWorker(workerPath, handleAddExtraLib, ramlResolver);
              _context3.next = 2;
              return this.worker.doWorkerMessageSync({
                type: _types.REGISTER_TYPE,
                clientConfig: clientConfig
              });
            case 2:
              this.isRegistered = true;
            case 3:
            case "end":
              return _context3.stop();
          }
        }, _callee3, this);
      }));
      function register(_x4, _x5, _x6) {
        return _register.apply(this, arguments);
      }
      return register;
    }() /** Unregister sanbox and close worker */)
  }, {
    key: "unregister",
    value: function unregister() {
      var _this$worker2;
      if ((_this$worker2 = this.worker) !== null && _this$worker2 !== void 0 && _this$worker2.terminate) {
        this.worker.terminate();
        this.worker = null;
      }
      this.isRegistered = false;
    }
  }]);
}();
//# sourceMappingURL=index.js.map